import { axios } from "utilities/axios";
import { IInteractionMessage, Route } from "@edgetier/watchtower-types";
import { useQuery, UseQueryOptions } from "react-query";
import { AxiosError } from "axios";

/**
 * Request the interaction ID from the backend using a message Id
 * @param url The URL of the interaction.
 * @returns The interaction ID.
 */
export const requestInteractionFromMessageId = async (url: string) => {
    const { data } = await axios.get<IInteractionMessage>(url);
    return data;
};

/**
 * A query for requesting an interaction message ID
 * @param interactionMessageId The ID of the message.
 * @returns Interaction
 */
export const useInteractionMessage = <T = IInteractionMessage>(
    interactionMessageId: string,
    configuration: UseQueryOptions<IInteractionMessage, AxiosError, T> = {}
) => {
    const url = Route.InteractionsMessage.replace(":interactionMessageId", interactionMessageId);
    return useQuery<IInteractionMessage, AxiosError, T>(
        [Route.InteractionsMessage, interactionMessageId],
        () => requestInteractionFromMessageId(url),
        configuration
    );
};
